module.exports = __webpack_public_path__ + "img/logo-raw.3667a890.png";